const handleToggleExpand = (setExpandedRows, rowId, columnId) => {
  setExpandedRows((prev) => ({
    ...prev,
    [rowId]: {
      ...prev[rowId],
      [columnId]: !prev[rowId]?.[columnId],
    },
  }));
};

export const renderLargeCell = (expandedRows, setExpandedRows, info, columnId) => {
  const isExpanded = expandedRows[info.row.id]?.[columnId];
  const rawValue = info.getValue();
  const value =
    rawValue === null || rawValue === undefined
      ? '-'
      : typeof rawValue === 'object'
        ? JSON.stringify(rawValue, null, 2)
        : String(rawValue);
  return (
    <div>
      {isExpanded ? value : value.length > 50 ? `${value.slice(0, 50)}...` : value}
      {value.length > 50 && (
        <button
          onClick={() => handleToggleExpand(setExpandedRows, info.row.id, columnId)}
          className="ml-2 text-blue-500"
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </button>
      )}
    </div>
  );
};
